import { Department } from 'model/Department';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'departments';

export namespace DepartmentState {
  export type Domain = {
    list: Resource<Department[]>;
    selectedList: number[];
    isAllDepartmentsSelected: boolean;
  };

  export const INITIAL_DOMAIN: Domain = {
    // Start PENDING so selectLegalFilters* doesn't strip URL filters before the API response arrives
    list: Resource.createPendingResource([]),
    selectedList: [],
    isAllDepartmentsSelected: false,
  };
}

export type DepartmentState = {
  departments: DepartmentState.Domain;
};
